import React from 'react';
import { Route } from 'react-router-dom';
import NewAddContrat from '../pages/production/contrats/NewAddContrat';
import Contrats from '../pages/production/contrats/Contrats';
import DetailsContrat from '../pages/production/contrats/DetailsContrat';
import PrintedContracts from '../pages/production/contrats/PrintedContracts';
import NonPrintedContrats from '../pages/production/contrats/NonPrintedContrats';
import Propositions from '../pages/production/contrats/Propositions';
import AddOldContratGUM from '../pages/production/contrats/AddOldContratGUM';
import Production from '../pages/production/Production';
import Bordereaux from '../pages/production/Bordereaux';
import STACFileConsumption from '../pages/production/STACFileConsumption';
import DetailsLotAttestations from '../pages/production/attestations/details-dispatch/DetailsLotAttestations';
import DetailsLotAttestationsDispatched from '../pages/production/attestations/details-dispatch/DetailsLotAttestationsDispatched';
import GestionDesAttestations from '../pages/production/attestations/gestion-des-attestations/GestionDesAttestations';
import NosCommandes from '../pages/production/attestations/commandes/NosCommandes';
import CompaniesCommandes from '../pages/production/attestations/commandes/CompaniesCommandes';
import DetailsCompagnie from '../pages/production/attestations/commandes/details/DetailsCompagnie';
import AgenceCommande from '../pages/production/attestations/commandes/details/AgenceCommande';
import CommandeAutorise from '../pages/production/attestations/commandes/CommandeAutorise';
import CommandeDelivre from '../pages/production/attestations/commandes/CommandeDelivre';
import CommandeConfirme from '../pages/production/attestations/commandes/CommandeConfirme';
import CommandeRejete from '../pages/production/attestations/commandes/CommandeRejete';
import CommandeReception from '../pages/production/attestations/commandes/CommandeReception';
import CommandeValides from '../pages/production/attestations/commandes/CommandeValides';

import DetailsLotAttestationsAgence from '../pages/production/attestations/DetailsLotAttestationsAgence';
import Assures from '../pages/assures/Assures';
import Encaissements from '../pages/caisse/Encaissements';
import Attestations from '../pages/caisse/Attestations';
import ReglementAttestation from '../pages/caisse/pages/ReglementAttestation';
import EnAttenteDEncaissement from '../pages/caisse/EnAttenteDEncaissement';
import VersementsEnCompagnie from '../pages/caisse/VersementsEnCompagnie';
import BorderauReversement from '../pages/caisse/BorderauReversement';
import CommissionsGenerees from '../pages/caisse/commissions/CommissionsGenerees';
import TransactionsMobileMoney from '../pages/production/components/TransactionsMobileMoney';
import RequireRights from '../components/services/RequireRights';

const ProductionRoutes = () => (
    <>
        <Route path="/production" element={<Production />} />
        <Route path="/ajouter-contrat" element={<NewAddContrat />} />
        <Route path="/editer-contrat/:contratId" element={<NewAddContrat />} />
        <Route path="/ajouter-contrat-new" element={<NewAddContrat />} />
        <Route path="/editer-contrat-new/:contratId" element={<NewAddContrat />} />
        <Route path="/ancien-contrat-gum" element={<AddOldContratGUM />} />
        <Route path="/details-contrat/:contratId" element={<DetailsContrat />} />
        <Route path="/contrats" element={<Contrats />} />
        <Route path="/contrats-imprimes" element={<PrintedContracts />} />
        <Route path="/contrats-non-imprimes" element={<NonPrintedContrats />} />
        <Route path="/propositions" element={<Propositions />} />
        <Route path="/bordereaux" element={<Bordereaux />} />
        <Route path="/assures" element={<Assures />} />
        <Route path="/encaissements" element={<Encaissements />} />
        <Route path="/en-attente-d-encaissement" element={<EnAttenteDEncaissement />} />
        <Route path="/versements-en-compagnie" element={<VersementsEnCompagnie />} />
        <Route path="/borderaux-de-versement-en-compagnie" element={<BorderauReversement />} />
        <Route path="/commissions-generees" element={<CommissionsGenerees />} />
        <Route path="/transactions-mobile-money" element={<TransactionsMobileMoney />} />
        <Route path="/mes-attestations" element={<DetailsLotAttestations />} />
        <Route path="/lots-attestations/:codeCompagnie" element={<DetailsLotAttestations />} />
        <Route path="/gestion-des-attestations" element={<GestionDesAttestations />} />
        <Route path="/dispatching-lot-attestation/:lotAttestationId" element={<DetailsLotAttestationsDispatched />} />
        <Route path="/dispatched-lots-attestations/:codeAgence" element={<DetailsLotAttestationsAgence />} />
        <Route path="/nos-commandes" element={<NosCommandes />} />
        <Route path="/compagnies-commandes" element={<CompaniesCommandes />} />
        <Route path="/commande/:commandeId" element={<DetailsCompagnie />} />
        <Route path="/commandes" element={<AgenceCommande />} />
        <Route path="/commandes-Autorisées" element={<CommandeAutorise />} />
        <Route path="/commandes-Delivrées" element={<CommandeDelivre />} />
        <Route path="/commandes-confirmées" element={<CommandeConfirme />} />
        <Route path="/commande-Rejetées" element={<CommandeRejete />} />
        <Route path="/commandes-receptionnées" element={<CommandeReception />} />
        <Route path="/commandes-validées" element={<CommandeValides />} />
        <Route path="/caisse/attestations" element={<Attestations />} />
        <Route path="/caisse/attestation/:commandeId" element={<ReglementAttestation />} />
        <Route element={<RequireRights codeHabilitation={"HCO021"} />}>
            <Route path="/production/port" element={<STACFileConsumption />} />
        </Route>
    </>
);

export default ProductionRoutes;
